
import React from 'react';
import { MessageSquareHeart, Trash2, Reply } from 'lucide-react';

interface MessageActionOverlayProps {
  onClose: () => void;
  onDelete: () => void;
  onReact: () => void;
  onReply: () => void;
  message: {
    content: string;
    sender_name: string;
  };
}

export const MessageActionOverlay: React.FC<MessageActionOverlayProps> = ({
  onClose,
  onDelete,
  onReact,
  onReply,
  message
}) => {
  // Close if clicking outside the dialog
  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="long-press-overlay" onClick={handleBackdropClick}>
      <div className="action-dialog">
        <div className="mb-3 pb-2 border-b">
          <div className="font-medium text-sm mb-1">Message from {message.sender_name}</div>
          <div className="text-xs text-muted-foreground line-clamp-2">{message.content}</div>
        </div>
        
        <button 
          className="action-button" 
          onClick={(e) => {
            e.stopPropagation();
            onReply();
          }}
        >
          <Reply className="h-5 w-5 action-button-icon text-primary" />
          <span className="action-button-text">Reply</span>
        </button>
        
        <button 
          className="action-button" 
          onClick={(e) => {
            e.stopPropagation();
            onReact();
          }}
        >
          <MessageSquareHeart className="h-5 w-5 action-button-icon text-pink-500" />
          <span className="action-button-text">React</span>
        </button>
        
        <button 
          className="action-button" 
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
        >
          <Trash2 className="h-5 w-5 action-button-icon text-destructive" />
          <span className="action-button-text text-destructive">Delete</span>
        </button>
      </div>
    </div>
  );
};
